import React from 'react';
import { THead, TH, Resizer, Sorter, Filter } from './styles';
import { HeaderGroup } from 'react-table';
import { zIndexPalette } from 'utils/styleConstants';
import styled from 'styled-components';

interface HeaderProps {
  headerGroups: HeaderGroup[];
  hasSort?: boolean;
  hasResize?: boolean;
  fixedColumns: number;
  onSortingChange?: Function;
  light: boolean;
  hideHeader: boolean;
  tableId: string;
}

const SorterContainer = styled.span`
  height: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`;

const SorterLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const Header = (props: HeaderProps) => {
  const { headerGroups, hasSort, hasResize, fixedColumns, light, onSortingChange, hideHeader, tableId } = props;

  return (
    <THead light={light} hideHeader={hideHeader}>
      {headerGroups.map((headerGroup, i) => (
        <tr
          {...headerGroup.getHeaderGroupProps()}
          key={`thead-tr-${i}`}
          data-walkthrough={`${tableId}-table-header-group`}
        >
          {headerGroup.headers.map((column, i) => {
            const customProps: { style?: React.CSSProperties } = {};
            if (fixedColumns > i && hasResize) {
              customProps.style = {
                position: 'sticky',
                zIndex: zIndexPalette.medium,
              };
            }

            return (
              <TH
                {...column.getHeaderProps(customProps)}
                width={fixedColumns > i ? column.width : 'auto'}
                left={fixedColumns > i ? column.totalLeft : undefined}
                key={`th-${i}`}
                className={`${fixedColumns > i ? 'fixed' : ''} ${fixedColumns === i + 1 ? 'last-fixed' : ''}`}
                data-walkthrough={`${tableId}-table-header-${column.id}`}
              >
                <div className="thLabel">
                  {column.canFilter && <Filter>{column.render('Filter')}</Filter>}
                  {hasSort && !column.disableSortBy && column.id !== 'selection' ? (
                    <SorterContainer
                      onClick={() => {
                        column?.toggleSortBy();

                        onSortingChange?.(
                          column.isSorted
                            ? column.isSortedDesc
                              ? undefined
                              : { id: column.id, desc: true }
                            : { id: column.id, desc: false },
                        );
                      }}
                    >
                      <SorterLabel>{column.render('Header')}</SorterLabel>
                      <Sorter isSorted={column.isSorted} isSortedDesc={column.isSortedDesc} />
                    </SorterContainer>
                  ) : (
                    <span>{column.render('Header')}</span>
                  )}
                  {hasResize && column.canResize && (
                    <Resizer
                      lastItem={fixedColumns === i + 1 || headerGroup.headers.length === i + 1}
                      {...column.getResizerProps()}
                    />
                  )}
                </div>
              </TH>
            );
          })}
        </tr>
      ))}
    </THead>
  );
};

export default React.memo(Header);
